import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { createCity, fetchCities } from "../../store/slices/locationSlice";

const CityCreatePopup = ({ show, onHide, onSuccess, selectedStateId }) => {
  const dispatch = useDispatch();

  const { states = [] } = useSelector((state) => state.location);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    stateId: selectedStateId || "",
  });

  useEffect(() => {
    if (selectedStateId) {
      setFormData((prev) => ({
        ...prev,
        stateId: selectedStateId,
      }));
    }
  }, [selectedStateId]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.stateId) {
      return;
    }

    try {
      setLoading(true);

      await dispatch(
        createCity({
          name: formData.name,
          stateId: Number(formData.stateId),
        }),
      ).unwrap();

      // REFRESH CITIES
      const refreshed = await dispatch(
        fetchCities(Number(formData.stateId)),
      ).unwrap();

      // FIND NEW CITY
      const latestCity = refreshed?.find((x) => x.name === formData.name);

      if (latestCity && onSuccess) {
        onSuccess(latestCity);
      }

      setFormData({
        name: "",
        stateId: "",
      });

      onHide();
    } catch (error) {
      console.error("Create City Error =>", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add City</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* STATE */}
        <div className="form_group mb-3">
          <label>State</label>

          <select
            className="form-control"
            name="stateId"
            value={formData.stateId}
            onChange={handleChange}
          >
            <option value="">Select State</option>

            {states.map((state) => (
              <option key={state.id} value={String(state.id)}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        {/* CITY NAME */}
        <div className="form_group mb-3">
          <label>City Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter city name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn_secondary" onClick={onHide}>
          Cancel
        </button>

        <button
          className="btn_primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CityCreatePopup;
